export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      name: 'AI Model Generators',
      url: '/apps',
      icon: 'icon-layers'
    },
    {
      name: 'Job Management',
      icon: 'fa fa-tasks',
      children: [
        {
          name: 'Job Definitions',
          url: '/jobsmget/jobdef',
          icon: 'fa fa-tasks',
        },
        {
          name: 'Jobs',
          url: '/jobsmget/job',
          icon: 'fa fa-tasks',
        }
      ]
    },
    {
      name: 'Model Analytics',
      icon: 'icon-chart',
      children: [
        {
          name: 'Training',
          url: '/analytics/training',
          icon: 'icon-chart',
        },
        {
          name: 'Newness',
          url: '/analytics/newness',
          icon: 'icon-chart',
        },
        {
          name: 'Robustness',
          url: '/analytics/robustness',
          icon: 'icon-chart',
        },
      ]
    },
    {
      name: 'Data Manager',
      icon: 'icon-puzzle',
      url: '/datamanager',
    },
    {
      name: 'Release Manager',
      icon: 'fa fa-tasks',
      children: [
        {
          name: 'New Releases',
          url: '/releasemgr',
          icon: 'icon-puzzle',
        },
        {
          name: 'Active Model',
          url: '/activemodelmgr',
          icon: 'icon-puzzle',
        },
        {
          name: 'Prior Releases',
          url: '/priorreleases',
          icon: 'icon-puzzle',
        },
      ]
    },
    {
      name: 'Asset AI Manager',
      icon: 'icon-layers',
      url: '/digitaltwin',
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/navigations.js